import { PROFILE_VIEW, All_INTERESTS, USER_INTERESTS, USER_SUBINTERESTS } from './actionTypes';
import { Auth, API, graphqlOperation, Hub } from 'aws-amplify';
import * as queries from '../../graphql/queries';
import { updateUserProfileDetails} from "../../graphql/mutations";
import { alertActions } from './alertActions';
import { loaderActions } from './loaderActions';
import Storage from "@aws-amplify/storage";
import MaleAvatar from '../../assets/MaleAvatar.png';
import FemaleAvatar from '../../assets/FemaleAvatar.png';
import { addEventLog } from "./../auth/util/util";
import moment from 'moment';
import fetchItemsNextToken from '../../graphql/fetchItemsNextToken';
import fetchSearchItemsNextToken from '../../graphql/fetchSearchItemsNextToken';


export const profileActions = {
  profileview,
  
};



function profileview(ownProfile) {
 
  

  return { type: PROFILE_VIEW, ownProfile:ownProfile};
}

export const getAllInterestsAction = () => async (dispatch) => {    
  let cardItemDataQuery=await fetchItemsNextToken({query:queries.listInterests,variables:{limit:500}})
  let getCardItemData=cardItemDataQuery.filter(item => item._deleted !== true).sort((a, b) => a.orderBy - b.orderBy);
  if(getCardItemData.length>0)
  {
      dispatch({type : All_INTERESTS,interests:getCardItemData});     
  }
  else
  {
      dispatch({type : All_INTERESTS,interests:[]});
  }
};


export const getUserInterestsAction = (userID) => async (dispatch) => {    
  if(userID!=null)
  {
    let cardItemDataQuery=await fetchSearchItemsNextToken({query:queries.searchInterestUsers,variables:{filter: {userProfileDetailsInterestsId: {eq: userID}},limit:500}})
    let getCardItemData=cardItemDataQuery.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    if(getCardItemData.length>0)
    {
        dispatch({type : USER_INTERESTS,userInterests:getCardItemData});     
    }
    else
    {
        dispatch({type : USER_INTERESTS,userInterests:[]});
    }
  }
  else
  {
      dispatch({type : USER_INTERESTS,userInterests:[]});
  }
  
};

export const getUserSubInterestsAction = (userID) => async (dispatch) => { 
  if(userID!=null)
  {   
    let cardItemDataQuery=await fetchSearchItemsNextToken({query:queries.searchSubinterestUsers,variables:{filter: {userProfileDetailsSubinterestsId: {eq: userID}},limit:500}})
    let getCardItemData=cardItemDataQuery.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    if(getCardItemData.length>0)
    {
        dispatch({type : USER_SUBINTERESTS,userSubInterests:getCardItemData});     
    }
    else
    {
        dispatch({type : USER_SUBINTERESTS,userSubInterests:[]});
    }
  }
  else
  {
      dispatch({type : USER_SUBINTERESTS,userSubInterests:[]});
  }
};